import { UserType } from '@quipex/shared/contracts';
import { ARCHITECT_PROMPTS } from './architect';
import { ASSET_MANAGER_PROMPTS } from './asset-manager';
import { BUILDING_AUTOMATION_SPECIALIST_PROMPTS } from './building-automation-specialist';
import { BUILDING_OWNER_PROMPTS } from './building-owner';
import { BUILDING_SUPERINTENDENT_PROMPTS } from './building-superintendent';
import { BUILDING_SURVEYOR_PROMPTS } from './building-surveyor';
import { COMPLIANCE_OFFICER_PROMPTS } from './compliance-officer';
import { CONSTRUCTION_MANAGER_PROMPTS } from './construction-manager';
import { CONSULTANT_PROMPTS } from './consultant';
import { CONVEYANCER_PROMPTS } from './conveyancer';
import { ENERGY_MANAGER_PROMPTS } from './energy-manager';
import { FACILITIES_MANAGER_PROMPTS } from './facilities-manager';
import { HOMEOWNER_PROMPTS } from './homeowner';
import { HVAC_TECHNICIAN_PROMPTS } from './hvac-technician';
import { INSURER_PROMPTS } from './insurer';
import { LAWYER_PROMPTS } from './lawyer';
import { LEASING_MANAGER_PROMPTS } from './leasing-manager';
import { MAINTENANCE_TECHNICIAN_PROMPTS } from './maintenance-technician';
import type { PromptDefinition } from './models';
import { OPERATIONS_MANAGER_PROMPTS } from './operations-manager';
import { OTHER_PROMPTS } from './other';
import { PORTFOLIO_MANAGER_PROMPTS } from './portfolio-manager';
import { PROJECT_MANAGER_PROMPTS } from './project-manager';
import { PROPERTY_MANAGER_PROMPTS } from './property-manager';
import { PROPERTY_VALUER_PROMPTS } from './property-valuer';
import { REAL_ESTATE_ANALYST_PROMPTS } from './real-estate-analyst';
import { REAL_ESTATE_DEVELOPER_PROMPTS } from './real-estate-developer';
import { SAFETY_MANAGER_PROMPTS } from './safety-manager';
import { STRATA_MANAGER_PROMPTS } from './strata-manager';
import { SUSTAINABILITY_MANAGER_PROMPTS } from './sustainability-manager';

export const PERSONA_PROMPTS = {
    [UserType.Homeowner]: HOMEOWNER_PROMPTS,
    [UserType.PropertyValuer]: PROPERTY_VALUER_PROMPTS,
    [UserType.Architect]: ARCHITECT_PROMPTS,
    [UserType.Lawyer]: LAWYER_PROMPTS,
    [UserType.Conveyancer]: CONVEYANCER_PROMPTS,
    [UserType.Insurer]: INSURER_PROMPTS,
    [UserType.PropertyManager]: PROPERTY_MANAGER_PROMPTS,
    [UserType.FacilitiesManager]: FACILITIES_MANAGER_PROMPTS,
    [UserType.MaintenanceTechnician]: MAINTENANCE_TECHNICIAN_PROMPTS,
    [UserType.AssetManager]: ASSET_MANAGER_PROMPTS,
    [UserType.PortfolioManager]: PORTFOLIO_MANAGER_PROMPTS,
    [UserType.RealEstateDeveloper]: REAL_ESTATE_DEVELOPER_PROMPTS,
    [UserType.BuildingOwner]: BUILDING_OWNER_PROMPTS,
    [UserType.LeasingManager]: LEASING_MANAGER_PROMPTS,
    [UserType.OperationsManager]: OPERATIONS_MANAGER_PROMPTS,
    [UserType.ProjectManager]: PROJECT_MANAGER_PROMPTS,
    [UserType.ComplianceOfficer]: COMPLIANCE_OFFICER_PROMPTS,
    [UserType.SafetyManager]: SAFETY_MANAGER_PROMPTS,
    [UserType.EnergyManager]: ENERGY_MANAGER_PROMPTS,
    [UserType.BuildingSuperintendent]: BUILDING_SUPERINTENDENT_PROMPTS,
    [UserType.RealEstateAnalyst]: REAL_ESTATE_ANALYST_PROMPTS,
    [UserType.SustainabilityManager]: SUSTAINABILITY_MANAGER_PROMPTS,
    [UserType.ConstructionManager]: CONSTRUCTION_MANAGER_PROMPTS,
    [UserType.BuildingAutomationSpecialist]:
        BUILDING_AUTOMATION_SPECIALIST_PROMPTS,
    [UserType.HvacTechnician]: HVAC_TECHNICIAN_PROMPTS,
    [UserType.Consultant]: CONSULTANT_PROMPTS,
    [UserType.Other]: OTHER_PROMPTS,
    [UserType.StrataManager]: STRATA_MANAGER_PROMPTS,
    [UserType.BuildingSurveyor]: BUILDING_SURVEYOR_PROMPTS,
} as const satisfies Record<UserType, readonly PromptDefinition[]>;
